import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  fileContainer: {
    display: "flex",
    flexDirection: "column",
    padding: spacing(1, 2),
    borderRadius: spacing(1),
    border: `1px solid ${palette.separator.main}`,
    color: palette.contrastText.main,
    background: palette.attachmentsBackground.main,
    marginBottom: spacing(1),
    maxWidth: "250px",
  },
  fileBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  fileName: {
    marginLeft: spacing(1),
    minWidth: "10px",
    maxWidth: "80%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  progress: {
    marginTop: spacing(1),
    height: "6px",
  },
  error: {
    border: "1px solid rgba(244, 67, 54, 1)",
  },
}));
